import styled from "styled-components";
import { Form, Input, InputNumber, Select, Modal, Switch } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { useState } from "react";

const { TextArea } = Input;

const labelWithRequired = (text) => (
  <span>
    {text}
    <Required>*</Required>
  </span>
);

const resolveIsActive = (deal) => {
  if (typeof deal?.isActive === "boolean") {
    return deal.isActive;
  }
  if (deal?.isActive === null) {
    return false;
  }
  if (typeof deal?.status === "string") {
    return deal.status === "active";
  }
  return true;
};

const BasicTab = ({ deal = {}, disabled }) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  return (
    <Card>
      {deal.imageUrl && (
        <ImageSection>
          <ImageSectionTitle>Зураг</ImageSectionTitle>
          <SelectedImageWrap>
            <img
              src={deal.imageUrl}
              alt={deal.masterName || "combo"}
              onClick={() => setPreviewOpen(true)}
            />
            <PreviewButton size="small" icon={<EyeOutlined />} onClick={() => setPreviewOpen(true)} />
          </SelectedImageWrap>
          <Modal
            open={previewOpen}
            title={deal.masterName || "Зураг"}
            footer={null}
            onCancel={() => setPreviewOpen(false)}
            centered
          >
            <img src={deal.imageUrl} alt={deal.masterName} style={{ width: "100%" }} />
          </Modal>
        </ImageSection>
      )}
      <Form layout="vertical">
        <FormGrid>
          <Form.Item label={labelWithRequired("Мастер нэр")}>
            <Input defaultValue={deal.masterName || "-"} disabled={disabled} />
          </Form.Item>

          <Form.Item
            label={labelWithRequired("SIMPHONY POS ID")}
          >
            <Input defaultValue={deal.comboMenuId || ""} disabled={disabled} />
          </Form.Item>

          <Form.Item label={labelWithRequired("Хүргэлтийн үнэ")}>
            <InputNumber
              value={deal.defaultPrice ?? null}
              disabled={disabled}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item label="Очиж авах үнэ">
            <InputNumber
              value={deal.pickupPrice ?? null}
              disabled={disabled}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item label="Tag">
            <Select
              mode="multiple"
              defaultValue={deal.tags?.length ? deal.tags : []}
              options={[
                { value: "normal", label: "normal" },
                { value: "vip", label: "vip" },
                { value: "seasonal", label: "seasonal" },
              ]}
              disabled={disabled}
            />
          </Form.Item>
          <Form.Item label="Идэвхтэй">
            <Switch checked={resolveIsActive(deal)} disabled={disabled} />
          </Form.Item>
          <Form.Item
            label={labelWithRequired("Комбо тайлбар")}
            style={{ gridColumn: "1 / -1" }}
          >
            <TextArea rows={4} defaultValue={deal.description || ""} disabled={disabled} />
          </Form.Item>
        </FormGrid>
      </Form>
    </Card>
  )
};

const Card = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 22px 24px 28px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(22, 119, 255, 0.16);
  backdrop-filter: blur(8px);
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(320px, 1fr) minmax(240px, 1fr);
  gap: 18px 24px;

  .ant-input,
  .ant-input-number,
  .ant-input-affix-wrapper,
  .ant-select-selector,
  .ant-input-number-input,
  .ant-input-number-affix-wrapper {
    border-radius: 6px !important;
    border-color: rgba(22, 119, 255, 0.2) !important;
    box-shadow: inset 0 0 0 1px rgba(22, 119, 255, 0.03);
  }

  .ant-select-selector {
    padding: 4px 12px !important;
  }

  .ant-form-item-label > label {
    color: #384353;
    font-weight: 600;
    letter-spacing: 0.02em;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const Required = styled.span`
  color: #e05858;
  margin-left: 4px;
`;

const ImageSection = styled.div`
  margin-bottom: 20px;
`;

const ImageSectionTitle = styled.h4`
  margin: 0 0 10px 0;
  font-size: 14px;
  font-weight: 600;
  color: #384353;
  letter-spacing: 0.02em;
`;

const SelectedImageWrap = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;

  img {
    width: 100%;
    max-height: 220px;
    object-fit: cover;
    border-radius: 6px;
    cursor: pointer;
    display: block;
  }
`;

const PreviewButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: none;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  transition: background 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.65);
  }
`;

export default BasicTab;
